import template from './atsi.html';
import controller from './atsi.controller';
import './atsi.styl';

let atsiComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default atsiComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/atsi/atsi.component.js